import React from 'react';
import { CheckCircle2, XCircle, Clock, Calendar, AlertTriangle } from 'lucide-react';
import type { AttendanceStatus, DeportmentStatus } from '@/lib/mockData';

interface AttendanceBadgeProps {
  status: AttendanceStatus;
}

export function AttendanceBadge({ status }: AttendanceBadgeProps) {
  const map: Record<AttendanceStatus, { className: string; icon: React.ReactNode }> = {
    Present: { className: 'status-badge-present', icon: <CheckCircle2 size={11} /> },
    Absent: { className: 'status-badge-absent', icon: <XCircle size={11} /> },
    Late: { className: 'status-badge-late', icon: <Clock size={11} /> },
    Excused: { className: 'status-badge-excused', icon: <Calendar size={11} /> },
    'On Leave': { className: 'status-badge-leave', icon: <Calendar size={11} /> },
  };
  const { className, icon } = map[status];
  return (
    <span className={className}>
      {icon}
      {status}
    </span>
  );
}

interface DeportmentBadgeProps {
  status: DeportmentStatus;
}

export function DeportmentBadge({ status }: DeportmentBadgeProps) {
  const map: Record<DeportmentStatus, { className: string; icon: React.ReactNode }> = {
    Compliant: { className: 'deportment-compliant', icon: <CheckCircle2 size={11} /> },
    'Non-Compliant': { className: 'deportment-non-compliant', icon: <XCircle size={11} /> },
    'Warning Issued': { className: 'deportment-warning', icon: <AlertTriangle size={11} /> },
  };
  const { className, icon } = map[status];
  return (
    <span className={className}>
      {icon}
      {status}
    </span>
  );
}

interface FlagBadgeProps {
  flag: 'OK' | 'At Risk' | 'Critical';
}

export function FlagBadge({ flag }: FlagBadgeProps) {
  const map = {
    OK: 'deportment-compliant',
    'At Risk': 'deportment-warning',
    Critical: 'deportment-non-compliant',
  };
  return <span className={map[flag]}>{flag}</span>;
}